import styled from "styled-components";

export const PageFeedback = styled.p`
  margin: 200px auto;
  text-align: center;
  font-size: 1.2rem;
`;
